import { useTranslation } from 'react-i18next'
import { useCompare } from '../hooks/useCompare'

interface CompareBarProps {
  onOpen: () => void
}

/** Floating bottom bar showing selected listings ready for comparison. */
export default function CompareBar({ onOpen }: CompareBarProps) {
  const { t } = useTranslation()
  const { count, clear, max } = useCompare()
  if (count === 0) return null
  return (
    <div className="compare-bar" role="region" aria-label={t('compare.barAria')}>
      <div className="compare-bar__inner">
        <span className="compare-bar__count">
          <strong>{count}</strong>
          {t('compare.barCountAfter', { max })}
        </span>
        <div className="compare-bar__actions">
          <button type="button" className="compare-bar__clear" onClick={clear}>
            {t('compare.barClear')}
          </button>
          <button
            type="button"
            className="compare-bar__open"
            onClick={onOpen}
            disabled={count < 2}
          >
            {t('compare.barOpen')}
          </button>
        </div>
      </div>
    </div>
  )
}
